import React from "react";
import "../PrivacyPolicyContent/PrivacyPolicyContent.css";
import "./FeedbackForm.css";
export const FeedbackForm = () => {
  return (
    <div className=" privacyBg">
      <div className="container formboxcontainer ">
        <div className="formbox">
          <h2 className="h2">Customer Feedback</h2>
          {/* <div > */}
          <label className="labelText spacingTop">
            Name*
            <input
              className="inputdesign"
              type="text"
              placeholder="Enter Name"
            />
          </label>
          {/* </div> */}
          <label className="labelText spacingTop">
            Email*
            <input  
              className="inputdesign"

            type="text" placeholder="Enter Email" />
          </label>

          <label className="labelText spacingTop">
            Message*
            <textarea
               className="inputdesign"
               style={{minHeight:"100px"}}
            placeholder="Enter Massage"></textarea>
          </label>
          <div>
            <button className="btn1 spacingTop">Send</button>
          </div>
        </div>
      </div>
    </div>
  );
};
